import ExpandableList from "../common/ExpandableList";
import {REST_TASK_GROUP_URL}  from "../common/constants";
import TaskGroup, {TaskGroupForm} from "./TaskGroup";


export const TaskGroupList = ExpandableList(TaskGroup, TaskGroupForm, REST_TASK_GROUP_URL, "taskGroup", "Typy úloh", "Nový typ úloh", "Přidat typ úloh" );

